import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';
import { getFormValues, isValid, reset } from 'redux-form';
import { Map, List, fromJS } from 'immutable';
import Hangul from 'hangul-js';

import { ExamList } from 'components';

import * as validFunc from 'libs/validation';
import * as examLib from 'libs/examLib';

import * as examListActions from 'modules/examList';
import * as examSummaryActions from 'modules/examSummary';
import * as currentStatusActions from 'modules/currentStatus';

let resizeExam;
let SEARCH_VALUE = '';
class CtExamList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      // scrollData: { isScroll: false, height: 400 },
      isLoadingLog: false,
      sendLog: '',
      isLoadingAddTag: false,
      loadingExamDelete: false,
      dropDirection: false,
      tempFilter: {}
    };

    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    const { isMounting } = this.props;
    // if (!isMounting) {
    this.onGetExamList(true);
    // }
    window.addEventListener('resize', this.onResize);
    // window.addEventListener('scroll', this.onScroll);
  }

  // 훈련 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    // 대상자 Height 설정
    // 데이터가 없으면 rf.scrollable이 아예 생성 안됨
    // const rf = this.refScroll;
    // if (!!rf && !!rf.scrollable) {
    //   const { heightData, numberOfChildren } = rf.state.infiniteComputer;
    //   const isScroll = heightData * numberOfChildren > rf.scrollable.parentElement.clientHeight;

    //   // 높이가 달라진 경우
    //   // 스크롤이 생성 여부
    //   if (
    //     rf.computedProps.containerHeight !== rf.scrollable.parentElement.clientHeight ||
    //     isScroll !== this.state.scrollData['isScroll']
    //   ) {
    //     this.setState({
    //       scrollData: { isScroll: isScroll, height: rf.scrollable.parentElement.clientHeight }
    //     });
    //   }
    // }

    const {
      needReload,
      selectedExamSummaryNo,
      examListParam,
      currentPath,
      examSummaryOrdering,
      examSummaryByExamNo,
      page,
      totalPage,
      examParam,
      startExamResult,
    } = this.props;
    if (
      // 훈련리스트 정보가 변경되었을때
      (needReload && !this.state.isLoading) ||
      // url이 변경되었을 경우
      (!!prevProps.currentPath && currentPath !== prevProps.currentPath) ||
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
      // 훈련의 데이터가 변경 되었을때
      examSummaryOrdering !== prevProps.examSummaryOrdering ||
      // 훈련의 데이터가 변경 되었을때
      examSummaryByExamNo !== prevProps.examSummaryByExamNo ||

      // 리스트 parameter가 변경되었을때
      JSON.stringify(examListParam) !== JSON.stringify(prevProps.examListParam) ||
      // 훈련 파라미터가 변경되었을때
      JSON.stringify(examParam) !== JSON.stringify(prevProps.examParam) ||
      // 훈련 실시 후
      startExamResult !== prevProps.startExamResult
    ) {
      this.onGetExamList(true);
    }

    // 테이블 높이가 변경되었을 때 리스트 높이가 더 작을 경우 리스트 조회
    if (
      this.listScroll &&
      this.listScroll.scrollHeight < this.listScroll.parentElement.scrollHeight
    ) {
      this.onGetExamList();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.onFilterCancel();
  }

  // 브라우저 리사이즈시의 처리
  onResize = () => {
    clearTimeout(resizeExam);
    resizeExam = setTimeout(() => {
      this.setState({
        dropDirection: window.innerHeight < 780 ? true : false
      });

      this.forceUpdate();
    }, 300);
  };

  // 스크롤 ref 등록
  onRefScroll = Scroll => {
    if (!!Scroll) {
      this.refScroll = Scroll;
    }
  };

  // 훈련 목록 조회
  onGetExamList = async refresh => {
    try {
      const {
        currentPath,
        CurrentStatusActions,
        ExamListActions,
        selectedExamSummaryNo,
        examListParam,
        page,
        totalPage
      } = this.props;

      // refresh가 true이면 무조건 새로 처리해야함
      if (!!refresh || !this.state.isLoading) {
        const { examListParam, examParam } = this.props;
        const param = {
          examNo: selectedExamSummaryNo,
          subTab: currentPath !== '/main/exam/pi' ? 'tag' : 'pi',
          filter: JSON.stringify(examListParam.get('filter')),
          sort: JSON.stringify(examListParam.get('sort')),
          offset: 0,
          limit: examListParam.get('limit')
        };

        // 전체 훈련의 경우 훈련 요약목록의 필터도 같이 보낸다.
        if (selectedExamSummaryNo === 'all' && examParam.get('filter').size > 0) {
          param['examFilter'] = JSON.stringify(examParam.get('filter'));
        }

        if (refresh) {
          this.setState({ isLoading: true });

          param['refresh'] = !!refresh;

          await ExamListActions.getExamList(param);
          CurrentStatusActions.initialExamList();
          this.setState({ isLoading: false });

          setTimeout(() => {
            !!this.refScroll && !!this.refScroll.scrollable && this.refScroll.handleScroll(0);
          }, 500);
        } else if (totalPage > page) {
          this.setState({ isLoading: true });

          param['offset'] = examListParam.get('limit') * page;

          await ExamListActions.getExamList(param);
          this.setState({ isLoading: false });
        }

        // if (!!examListParam.getIn(['filter', 'searchAll'])) {
        //   this.setState({ searchText: examListParam.getIn(['filter', 'searchAll']) });
        // }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 훈련 필터 타입
  onFilterType = type => {
    const { ExamListActions } = this.props;
    const { tempFilter } = this.state;

    const filter = Object.assign({}, tempFilter);
    if (typeof filter['filterType'] === 'undefined' || filter['filterType'] === 'and') {
      filter['filterType'] = 'or';
    } else {
      filter['filterType'] = 'and';
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 훈련 필터
  onFilterItem = data => {
    const { tempFilter } = this.state;
    const {
      // 훈련 전체 정보
      examSummaryByExamNo,
      // 선택한 훈련 번호
      selectedExamSummaryNo
    } = this.props;
    examSummaryByExamNo.get(String(selectedExamSummaryNo));

    const filter = Object.assign({}, tempFilter);
    if (typeof filter['filterType'] === 'undefined') {
      filter['filterType'] = 'or';
    }

    if (typeof filter[data.value] === 'undefined') {
      filter[data.value] = 1;
    } else {
      delete filter[data.value];

      if (Object.keys(filter).length === 1) {
        delete filter['filterType'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 필터 초기화
  onFilterCancel = () => {
    const { ExamListActions } = this.props;

    ExamListActions.changeExamListParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };

  // 훈련 결과 정렬
  onSortOrdering = e => {
    const { ExamListActions, examListParam } = this.props;

    let orderValue = 'DESC';
    if (examListParam.get('sort')[0]['order'] === 'DESC') {
      orderValue = 'ASC';
    }
    ExamListActions.changeExamListParam({
      name: 'sort',
      value: [{ order: orderValue, field: examListParam.get('sort')[0]['field'] }]
    });
  };

  // 훈련 결과 정렬
  onSort = (e, data) => {
    const { ExamListActions, examListParam } = this.props;

    ExamListActions.changeExamListParam({
      name: 'sort',
      value: [{ field: data.value, order: examListParam.get('sort')[0]['order'] }]
    });
  };

  // 훈련 결과 검색
  onSearch = e => {
    let searchValue = '';
    if (e.key === 'Enter' || e.target.id === 'bt-searchExam' || e.target.parentNode.id === 'bt-searchExam') {
      // searchValue = this.searchText;
      searchValue = SEARCH_VALUE;

      const { ExamListActions, examListParam } = this.props;
      const filter = examListParam.get('filter').toJS();
      if (searchValue !== filter['searchAll']) {
        // filter 지우기
        if (searchValue === '') {
          delete filter['searchAll'];
        } else {
          filter['searchAll'] = searchValue;
        }

        ExamListActions.changeExamListParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 현재 훈련의 필터상태로 태그 생성
  onAddTag = async e => {
    try {
      if (!this.state.isLoadingAddTag) {
        this.setState({ isLoadingAddTag: true });
        // 국제화 처리
        const { formatMessage } = this.props.intl;
        const { formExamAddTag, formExamAddTagIsValid, formExamAddTagStore } = this.props;

        if (formExamAddTagIsValid && !await validFunc.tagNameValidate(formExamAddTag.tagName)) {
          const params = {
            examNo: formExamAddTag.examNo,
            tagName: formExamAddTag.tagName,
            tagInitial: Hangul.disassemble(formExamAddTag.tagName)[0],
            filter: formExamAddTag.filter,
            // 나중에 태그에서 추가시를 위해서 변경가능하도록 처리
            subTab: 'pi'
          };

          const respObj = await examLib.postAddTag(params);
          if (respObj && respObj.status && respObj.status === 200) {
            if (respObj.data && Array.isArray(respObj.data.list)) {
              this.onToggleModal('');
              this.onToggleSnackbar(
                "'" +
                respObj.data.list[0].tagName +
                "' " +
                defineMessages(formatMessage({ id: 'ModalTagAdd_2', defaultMessage: '태그 생성' }))
              );
            } else {
              // 응답 데이터 오류
            }
          } else {
            // 응답 오류
          }
        }
        this.setState({ isLoadingAddTag: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 발송 실패 로그 호출
  onGetExamTarget = async (examNo, targetNo) => {
    try {
      if (!this.state.isLoadingLog) {
        this.setState({ isLoadingLog: true });
        const param = {
          examNo,
          targetNo
        };

        const respObj = await examLib.getExamTarget(param);
        if (respObj && respObj.status && respObj.status === 200) {
          if (respObj.data && Array.isArray(respObj.data.list)) {
            this.setState({ sendLog: respObj.data.list[0] });
          } else {
            // 응답 데이터 오류
          }
        } else {
          // 응답 오류
        }

        this.setState({ isLoadingLog: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 모달 처리
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset, CurrentStatusActions } = this.props;
    ReduxFormReset('formExamAddTag');

    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 훈련 삭제
  onExamDeleteModal = async () => {
    try {
      this.setState({ loadingExamDelete: true });

      const { selectedExamList, ExamSummaryActions } = this.props;

      await ExamSummaryActions.deleteExam({ examNoArray: selectedExamList.get('noArray') });

      this.onToggleModal('');
      this.setState({ loadingExamDelete: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  // 전체 선택 체크박스
  handleCheckAllExamList = e => {
    const { CurrentStatusActions, examListOrdering, selectedExamList } = this.props;

    // 전체 선택
    if (examListOrdering.size !== selectedExamList.get('noArray').size) {
      CurrentStatusActions.checkAllExamList({ noArray: examListOrdering, isAllCheckExamList: 1 });
      // 해제
    } else {
      CurrentStatusActions.checkAllExamList({ noArray: [], isAllCheckExamList: 0 });
    }
  };

  // 체크 이벤트
  handleCheckExamList = (selectNo, shiftCheck) => {
    const { CurrentStatusActions, examListOrdering, selectedExamList } = this.props;

    if (shiftCheck && selectedExamList.get('lastCheck') !== 0) {
      // true면 지우기 false는 추가
      const isRemove = selectedExamList.get('noArray').indexOf(selectedExamList.get('lastCheck')) === -1 ? true : false;
      const startNo = examListOrdering.findIndex(eNo => eNo === selectedExamList.get('lastCheck'));
      const endNo = examListOrdering.findIndex(eNo => eNo === selectNo);

      const examArray = [];
      examListOrdering.map((examNo, index) => {
        if ((startNo <= index && index <= endNo) || (endNo <= index && index <= startNo)) {
          examArray.push(examNo);
        }
      });

      CurrentStatusActions.checkExamListMulti({ selectNo, examArray, isRemove, totalExamList: examListOrdering.size });
    } else {
      CurrentStatusActions.checkExamList({ selectNo, totalExamList: examListOrdering.size });
    }
  };

  // 선택 이벤트
  handleSelectExamList = selectNo => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.selectExamList({ selectNo });
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //체크 취소
  cancleCheck = () => {
    const { ExamListActions, examListParam } = this.props;
    const filter = examListParam.get('filter').toJS();
    this.setState({
      tempFilter: filter
    });
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { examListParam } = this.props;
    const filter = examListParam.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { ExamListActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    ExamListActions.changeExamListParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 스크롤 움직일 시 발생하는 이벤트
  onScroll = () => {
    if (!this.listScroll) return;

    // 스크롤 끝까지 내려갔을 시 api 호출
    if (this.listScroll.scrollHeight <= this.listScroll.scrollTop + this.listScroll.offsetHeight) {
      this.onGetExamList();
    }
  }

  scrollRef = ref => {
    this.listScroll = ref;
  }

  render() {
    const {
      currentPath,
      selectedExamSummaryNo,
      selectedExamList,
      examListOrdering,
      examListByNo,
      examSummaryByExamNo,
      page,
      totalPage,
      examListParam,
      tagDataByTagNo,
      isModal
    } = this.props;
    // function
    const {
      onGetExamList,
      onRefScroll,
      onGetExamTarget,
      onToggleModal,
      handleSelectExamList,
      handleCheckExamList
    } = this;
    // 검색용 function
    const {
      onFilterType,
      onFilterItem,
      onFilterCancel,
      onSortOrdering,
      onSort,
      handleChangeSearchText,
      onSearch,
      onAddTag,
      handleCheckAllExamList,
      onExamDeleteModal,
      searchTextRef,
      executeFilter,
      cancleCheck,
      filterClose
    } = this;

    return (
      <ExamList
        currentPath={currentPath}
        selectedExamSummaryNo={selectedExamSummaryNo}
        examListOrdering={examListOrdering}
        examListByNo={examListByNo}
        selectedExamList={selectedExamList}
        examSummaryByExamNo={examSummaryByExamNo}
        // scrollData={this.state.scrollData}
        isModal={isModal}
        isLoading={this.state.isLoading}
        dropDirection={this.state.dropDirection}
        page={page}
        totalPage={totalPage}
        examListParam={examListParam}
        tagDataByTagNo={tagDataByTagNo}
        // function
        onGetExamList={onGetExamList}
        // onRefScroll={onRefScroll}
        onScroll={this.onScroll}
        scrollRef={this.scrollRef}
        handleSelectExamList={handleSelectExamList}
        handleCheckExamList={handleCheckExamList}
        takeSearchValue={this.takeSearchValue}
        tempFilter={this.state.tempFilter}
        // 검색용 function
        examSearchProps={{
          // 필터
          onFilterType: onFilterType,
          onFilterItem: onFilterItem,
          onFilterCancel: onFilterCancel,
          searchTextRef: searchTextRef,
          executeFilter: executeFilter,
          cancleCheck: cancleCheck,
          filterClose: filterClose,
          // 정렬
          onSortOrdering: onSortOrdering,
          onSort: onSort,
          // 검색
          // searchText: this.searchText,
          searchText: SEARCH_VALUE,
          handleChangeSearchText: handleChangeSearchText,
          onSearch: onSearch,
          // 태그 추가
          onAddTag: onAddTag,
          isClicked: this.state.isLoadingAddTag,
          onToggleModal: onToggleModal,
          // 전체 선택
          handleCheckAllExamList: handleCheckAllExamList
        }}
        // 발송 실패 로그
        sendLogData={{
          isLoading: this.state.isLoadingLog,
          logData: this.state.sendLog,
          onGetExamTarget: onGetExamTarget
        }}
        loadingExamDelete={this.state.loadingExamDelete}
        onExamDeleteModal={onExamDeleteModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  needReload: state.examList.get('needReload'),
  examListParam: state.examList.get('param'),
  page: state.examList.get('page'),
  totalPage: state.examList.get('totalPage'),
  examListOrdering: state.examList.get('examListOrdering'),
  examListByNo: state.examList.get('examListByNo'),
  examParam: state.examSummary.get('param'),
  isMounting: state.examSummary.get('isMounting'),
  examSummaryOrdering: state.examSummary.get('examSummaryOrdering'),
  examSummaryByExamNo: state.examSummary.get('examSummaryByExamNo'),
  startExamResult: state.exam.get('startExamResult'),
  isModal: state.currentStatus.get('isModal'),
  selectedExamSummaryNo: state.currentStatus.getIn(['examSummary', 'selected']),
  selectedExamList: state.currentStatus.getIn(['examList', 'selected']),
  tagDataByTagNo: state.tag.get('tagDataByTagNo'),
  formExamAddTagStore: state.form['formExamAddTag'],
  formExamAddTag: getFormValues('formExamAddTag')(state),
  formExamAddTagIsValid: isValid('formExamAddTag')(state)
});

const mapDispatchToProps = dispatch => ({
  ExamListActions: bindActionCreators(examListActions, dispatch),
  ExamSummaryActions: bindActionCreators(examSummaryActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamList));



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamList.js